var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal-mask",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.closeModal()
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-wrapper",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeModal()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-container" }, [
              _c(
                "div",
                { staticClass: "modal-header" },
                [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("Aguardando distribuição")
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { id: "btn", type: "text", size: "mini" },
                      on: { click: _vm.closeModal },
                      nativeOn: {
                        mouseover: function($event) {
                          return _vm.hover($event)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons icon" }, [
                        _vm._v("close")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("el-row", { staticClass: "pross" }, [
                    _c("p", [
                      _vm._v("Processo:"),
                      _c("b", [
                        _vm._v("  " + _vm._s(_vm.processo.numeroProcesso))
                      ])
                    ])
                  ]),
                  _c("el-row", { staticClass: "row" }, [
                    _c("p", [
                      _vm._v(
                        "Selecione abaixo o perfil a ser vinculado o processo:"
                      )
                    ])
                  ]),
                  _c("app-label", {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { label: "Status:" }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width select",
                      attrs: { placeholder: "Selecione o perfil" },
                      model: {
                        value: _vm.acao,
                        callback: function($$v) {
                          _vm.acao = $$v
                        },
                        expression: "acao"
                      }
                    },
                    _vm._l(_vm.tasks, function(task, index) {
                      return _c("el-option", {
                        key: task.valor,
                        attrs: { label: task.nome, value: task.valor }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _vm._t("footer", [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.distribuirProcesso }
                      },
                      [_vm._v("Confirmar")]
                    )
                  ])
                ],
                2
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20425080", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20425080","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/components/modal/AppModalDistribuicao.vue
// module id = null
// module chunks = 